import React, { useEffect, useMemo, useState, useRef } from 'react'
import { AppTitlePage } from '../../components/AppTitlePage'
import AppBtn, { AppBtnColor, AppBtnSize } from '../../components/btn/AppBtn'
import { useParamsControl } from '../../utils/useParamsControl'
import {
  IPlanMenuCloseOrdersRequest,
  IUpdatePlanMenuCloseOrderDto,
} from '../../core/api/dto/PlanMenuCloseDto'
import { PlanMenuCloseList } from './components/PlanMenuListClose'
import { ITag } from '../../core/api/dto/TagsDto'
import {
  useGetPlanMenuCloseOrderQuery,
  useUpdatePlanMenuCloseOrderMutation,
} from '../../core/api/PlanMenuCloseApi'
import { useGetParamQuery } from '../../utils/useGetParamQuery'
import { PlanMenuStatusType } from '../../core/api/dto/PlanMenuControlDto'
import {
  AppNotification,
  NotificationType,
} from '../../components/notification/Notification'
import { AppFilterDateInput } from '../../components/AppInput/AppFilterDateInput'
import { useIsAdmin } from '../../utils/useIsAdmin'
import moment from 'moment'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { useGetWidth } from 'utils/useGetWidth'

import AddMilletPopup from './components/MilletPopup/AddMilletPopup'
import { useGetBuffetMilletQuery } from 'core/api/BuffetMilletApi'
import AppDropdownWithPhotoAndPagination from 'components/AppDropdown/AppDropdownWithPhotoAndPagination'
import { IMillet } from 'core/api/dto/MilletObjDto'

import { useSearchParams } from 'react-router-dom'
import { MainBlock } from './components/MainBlock'
import { InfoBlock } from './components/InfoBlock'
import { AppLoader, LoaderType } from 'components/AppLoader'
import { AppTabsBlock } from 'shared/ui/AppTabsBlock'
import { DishBlock } from './components/DishBlock'
import AddDishPopup from './components/DishPopap/AddDishPopup'
import ZeroClientsPopup from './components/ZeroClientsPopup/ZeroClientsPopup'

export enum DetailTab {
  'info' = 'info',
  'main' = 'main',
  'dish' = 'dish',
  // 'delete' = 'delete',
}
export const PlanMenuClosePage = () => {
  const { t } = useTranslation()
  const { width } = useGetWidth()
  const pageParams = useParamsControl<
    IPlanMenuCloseOrdersRequest,
    keyof IPlanMenuCloseOrdersRequest
  >({
    withPagination: true,
    whiteList: [
      'search',
      'order_date_execution_gte',
      'order_date_execution_lte',
      'millet',
    ],
  })
  const isAdmin = useIsAdmin()
  const orderId = useGetParamQuery('order')
  const dishId = useGetParamQuery('dish')
  const dimensionId = useGetParamQuery('dimension')
  const { data: orderDetail, isFetching } = useGetPlanMenuCloseOrderQuery(
    { id: Number(orderId || 0) },
    { skip: !orderId },
  )

  const [updateOrder, { isLoading: isLoadingClose }] =
    useUpdatePlanMenuCloseOrderMutation()
  const [searchParams, setSearchParams] = useSearchParams()
  const [editMode, setEditMode] = useState<boolean>(false)
  const [localComments, setLocalComments] = useState<string>('')
  const [comments, setComments] = useState<string>('')
  const [tags, setTags] = useState<ITag[]>([])
  const [numberOfSold, setNumberOfSold] = useState<number>(0)
  const [numberOfPersonsFact, setNumberOfPersonsFact] = useState<number>(0)
  const [activeTab, setActiveTab] = useState<DetailTab>(DetailTab.info)
  const [isShowPopup, setIsShowPopup] = useState<boolean>(false)
  const [isShowDishPopup, setIsShowDishPopup] = useState<boolean>(false)
  const [isOneDimension, setIsOneDimension] = useState<boolean>(false)
  const [currentMillet, setCurrentMillet] = useState<null | IMillet>(null)
  const [reloadTrigger, setReloadTrigger] = useState<boolean>(false)
  const navigate = useNavigate()
  const startDateString = moment(orderDetail?.dateStart).format('YYYY-MM-DD')
  const endDateString = moment(orderDetail?.dateEnd).format('YYYY-MM-DD')
  const [isShowZeroUsersPopup, setIsShowZeroUsersPopup] = useState(false)
  const clientsInputRef = useRef<HTMLInputElement>(null)

  const redirectString = `/buffet-report-vz/line-report/?report_type=full&dimension_date_lte=${startDateString}&dimension_date_gte=${endDateString}&go_back_pl=true`
  useEffect(() => {
    if (!!orderDetail) {
      setComments(orderDetail?.comment || '')
      setTags(orderDetail.orderTags)
      setNumberOfSold(orderDetail.numberOfSold || 0)
      setNumberOfPersonsFact(orderDetail.numberOfPersonsFact || 0)
    }
  }, [orderDetail])
  const onChangeCurrentMillet = (value: null | IMillet) => {
    setCurrentMillet(value)
    searchParams.set('millet', `${value?.id}`)
    searchParams.delete('order')
    searchParams.delete('dish')
    searchParams.delete('dimension')
    searchParams.delete('index')
    setSearchParams(searchParams.toString(), { replace: true })
  }
  const resetValueHandler = () => {
    setCurrentMillet(null)
    searchParams.delete('millet')
    searchParams.delete('order')
    searchParams.delete('dish')
    searchParams.delete('dimension')
    searchParams.delete('index')
    setSearchParams(searchParams.toString(), { replace: true })
  }
  const updateOrderHandler = () => {
    if (!!orderId && editMode) {
      const newOrder: IUpdatePlanMenuCloseOrderDto = {
        comment: localComments || ' ',
        numberOfPersonsFact,
        numberOfSold,
        orderTags: tags.map((tag) => tag.id),
      }
      const data: IUpdatePlanMenuCloseOrderDto = Object.fromEntries(
        Object.entries(newOrder).filter(([key, value]) => !!key && !!value),
      )
      updateOrder({ id: Number(orderId), data })
        .unwrap()
        .then(() =>
          AppNotification({
            msg: t('План-меню отредактирован!'),
            type: NotificationType.success,
          }),
        )
    }
    setEditMode((prevState) => !prevState)
  }

  const closePlanMenu = () => {
    if (!!orderId) {
      if (
        (orderDetail?.numberOfPersonsFact || 0) === 0 &&
        orderDetail?.planMenuStatus === PlanMenuStatusType.Opened
      ) {
        setIsShowZeroUsersPopup(true)
        return
      }

      const isOpen = orderDetail?.planMenuStatus === PlanMenuStatusType.Opened
      const newStatus: IUpdatePlanMenuCloseOrderDto = {
        planMenuStatus: isOpen
          ? PlanMenuStatusType.Closed
          : PlanMenuStatusType.Opened,
      }

      updateOrder({ id: Number(orderId), data: newStatus })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t(`План-меню успешно ${isOpen ? 'закрыт' : 'открыт'}!`),
            type: NotificationType.success,
          })
          setReloadTrigger(true)
        })
    }
  }

  const setActiveTabHandler = (value: DetailTab) => {
    if (value === DetailTab.main) {
    }
    setActiveTab(value)
  }

  const actions = useMemo(
    () => [
      {
        btnTitle: 'Перейти в отчет',
        onClick: () => navigate(redirectString),
        color: AppBtnColor.lightViolet,
        disabled: orderDetail?.planMenuStatus === PlanMenuStatusType.Opened,
      },
      {
        btnTitle:
          orderDetail?.planMenuStatus === PlanMenuStatusType.Opened
            ? 'Закрыть план-меню'
            : 'Открыть план-меню',
        onClick: closePlanMenu,
        color: AppBtnColor.violetWhite,
        disabled:
          // process.env.REACT_APP_TYPE_SERVER === 'MainServer' ||
          editMode || isLoadingClose,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      orderDetail,
      localComments,
      tags,
      numberOfSold,
      numberOfPersonsFact,
      orderId,
      editMode,
      closePlanMenu,
      updateOrderHandler,
    ],
  )

  return (
    <div className="width-for-page-wrapper plan-menu-close-page">
      <AppTitlePage
        title={'Закрытие план-меню'}
        actions={orderId && orderDetail ? actions : undefined}
      />
      <div className="filter-block mt-20">
        {isAdmin && (
          <div>
            <label>{t('Период исполнения')}</label>
            <div className="input-row mt-10">
              <AppFilterDateInput searchParam={'order_date_execution_gte'} />
              <AppFilterDateInput searchParam={'order_date_execution_lte'} />
              <AppDropdownWithPhotoAndPagination
                placeholder={t('Выбрать тару')}
                value={currentMillet}
                onChange={onChangeCurrentMillet}
                getterData={useGetBuffetMilletQuery}
                resetValueHandler={resetValueHandler}
                propToShowInInput={'name'}
                propToShowInList={'name'}
                propToShowPhotoS3={'imageOnS3'}
                propToShowPhoto={'image'}
                propToShowWheight={'weight'}
                fullWidth
                border
                required
                id="millet"
              />
            </div>
          </div>
        )}
      </div>
      <div className="plan-menu-control-page close mt-15">
        <div className={`width-${width <= 1024 ? 100 : 25}`}>
          <PlanMenuCloseList
            pageParams={pageParams}
            setEditMode={setEditMode}
            reloadTrigger={reloadTrigger}
            setReloadTrigger={setReloadTrigger}
          />
        </div>
        {orderDetail && orderId && (
          <AppTabsBlock<DetailTab>
            tabs={[
              { name: t('Информация'), value: DetailTab.info },
              { name: t('Присвоить тару'), value: DetailTab.main },
              { name: t('Заменить блюдо'), value: DetailTab.dish },
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTabHandler}
            className="width-100 "
            underBlock={
              activeTab === DetailTab.info &&
              !isFetching && (
                <div className={` buttons-block-history`}>
                  <div
                    className={`width-${
                      width <= 1024 ? (width <= 768 ? 100 : 50) : 50
                    } `}
                  >
                    <div className="buttons-block">
                      {editMode && (
                        <AppBtn
                          title={'Отменить'}
                          color={AppBtnColor.outlineViolet}
                          iconClassName={'close'}
                          sized={AppBtnSize.md}
                          onClick={() => {
                            setTags(orderDetail.orderTags)
                            setLocalComments('')
                            setEditMode(false)
                            setNumberOfPersonsFact(
                              orderDetail.numberOfPersonsFact || 0,
                            )
                            setNumberOfSold(orderDetail.numberOfSold || 0)
                          }}
                        />
                      )}
                      <AppBtn
                        iconClassName={editMode ? 'save' : ''}
                        title={editMode ? 'Сохранить' : 'Редактировать'}
                        sized={AppBtnSize.md}
                        color={
                          editMode
                            ? AppBtnColor.violetWhite
                            : AppBtnColor.lightViolet
                        }
                        onClick={updateOrderHandler}
                        disabled={
                          orderDetail?.planMenuStatus ===
                          PlanMenuStatusType.Closed
                        }
                      />
                    </div>
                  </div>
                </div>
              )
            }
          >
            {activeTab === DetailTab.main && (
              <>
                {isFetching ? (
                  <AppLoader loaderType={LoaderType.info} />
                ) : (
                  <MainBlock
                    width={width}
                    orderDetail={orderDetail}
                    orderId={orderId}
                    dishId={dishId}
                    dimensionId={dimensionId}
                    pageParams={pageParams}
                    setIsShowPopup={() => {
                      setIsOneDimension(false)
                      setIsShowPopup(true)
                    }}
                    setIsShowOnePopup={() => {
                      setIsOneDimension(true)
                      setIsShowPopup(true)
                    }}
                  />
                )}
              </>
            )}
            {activeTab === DetailTab.info && (
              <>
                {isFetching ? (
                  <AppLoader loaderType={LoaderType.info} />
                ) : (
                  <InfoBlock
                    width={width}
                    orderId={orderId}
                    orderDetail={orderDetail}
                    editMode={editMode}
                    numberOfSold={numberOfSold}
                    comments={comments}
                    setComments={setComments}
                    tags={tags}
                    setTags={setTags}
                    setNumberOfSold={(value) => setNumberOfSold(Number(value))}
                    setNumberOfPersonsFact={(value) =>
                      setNumberOfPersonsFact(Number(value))
                    }
                    numberOfPersonsFact={numberOfPersonsFact}
                    setLocalComments={setLocalComments}
                    clientsInputRef={clientsInputRef}
                  />
                )}
              </>
            )}
            {activeTab === DetailTab.dish && (
              <>
                {isFetching ? (
                  <AppLoader loaderType={LoaderType.info} />
                ) : (
                  <DishBlock
                    width={width}
                    orderDetail={orderDetail}
                    orderId={orderId}
                    dishId={dishId}
                    dimensionId={dimensionId}
                    pageParams={pageParams}
                    setIsShowPopup={() => {
                      setIsShowDishPopup(true)
                    }}
                  />
                )}
              </>
            )}
          </AppTabsBlock>
        )}
      </div>
      {isShowPopup && (
        <AddMilletPopup
          dimensionId={dimensionId}
          setIsShowPopup={setIsShowPopup}
          isOneDimension={isOneDimension}
          dishId={dishId}
        />
      )}
      {isShowDishPopup && (
        <AddDishPopup
          orderDetail={orderDetail}
          dimensionId={dimensionId}
          setIsShowPopup={setIsShowDishPopup}
          dishId={dishId}
        />
      )}
      {isShowZeroUsersPopup && (
        <ZeroClientsPopup
          onClose={() => setIsShowZeroUsersPopup(false)}
          onAdd={() => {
            setIsShowZeroUsersPopup(false)
            setEditMode(true)
            setTimeout(() => clientsInputRef.current?.focus(), 100)
          }}
        />
      )}
    </div>
  )
}
